import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  detachedBox: {
    backgroundColor: theme.palette.primary.light,
    padding: '9px',
    borderRadius: '4px',
  },
  inactiveBox: {
    backgroundColor: theme.palette.secondary.superLight,
    padding: '9px',
    borderRadius: '4px',
  },
  answered: {
    backgroundColor: theme.palette.statusLabel.success.secondary,
    color: theme.palette.statusLabel.success.primary,
    fontWeight: 700,
    height: '21px',
  },
  pending: {
    backgroundColor: theme.palette.statusLabel.pending.secondary,
    color: theme.palette.statusLabel.pending.primary,
    fontWeight: 700,
    height: '21px',
  },
  linkButton: {
    color: theme.palette.text.link,
    '&:hover': {
      textDecoration: 'underline',
      backgroundColor: 'transparent',
    },
  },
  linkText: {
    color: theme.palette.text.link,
    fontWeight: 700,
  },
  endFormControl: {
    marginRight: 0,
  },
  boxStatus: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),

    [theme.breakpoints.up('md')]: {
      alignItems: 'flex-end',
    },
  },
  riskBadge: {
    color: theme.palette.white,
    fontWeight: 700,
    height: '21px',
  },
  questionsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },
  // Card da questão em três faixas: cabeçalho (número, tema e pergunta), corpo
  // (campos de resposta) e rodapé (autoria e ação). A borda esquerda na cor do
  // status separa pendentes de respondidas dentro da aba "Todas".
  questionCard: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.white,
    overflow: 'hidden',
  },
  // A cor do status marca só a faixa do cabeçalho, e não a lateral inteira do
  // card: o traço acompanha a altura do tema + pergunta.
  questionHeaderAnswered: {
    borderLeftColor: theme.palette.statusLabel.success.primary,
  },
  questionHeaderPending: {
    borderLeftColor: theme.palette.statusLabel.pending.primary,
  },
  // Cabeçalho encostado no corpo: a pergunta e as alternativas são o mesmo
  // assunto, então não ganham o espaçamento cheio entre blocos.
  questionHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
    padding: theme.spacing(2, 2, 1),
    borderLeftWidth: 4,
    borderLeftStyle: 'solid',
  },
  // Chip de status na linha do tema, nas mesmas cores da borda do card.
  statusChip: {
    fontWeight: 700,
    height: theme.spacing(2.5),
  },
  chipAnswered: {
    backgroundColor: theme.palette.statusLabel.success.secondary,
    color: theme.palette.statusLabel.success.primary,
  },
  chipPending: {
    backgroundColor: theme.palette.statusLabel.pending.secondary,
    color: theme.palette.statusLabel.pending.primary,
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
  },
  // O tema classifica a pergunta: subtitle2 (a mesma dos labels dos campos do
  // card), em cinza para ficar abaixo da pergunta na hierarquia.
  themeLabel: {
    color: theme.palette.text.secondary,
  },
  // A pergunta é o conteúdo principal do card: h5 do tema, sem sobrescrever
  // peso ou família.
  questionText: {
    lineHeight: 1.4,
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
  },
  questionHeading: {
    flexGrow: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },
  // Um único ritmo vertical de theme.spacing(2) entre alternativas,
  // justificativa e evidência.
  questionBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    padding: theme.spacing(2),
  },
  questionFooter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: theme.spacing(2),
    padding: theme.spacing(0, 2, 2),
  },
  replierName: {
    marginRight: 'auto',
  },
  replierNameHighlight: {
    fontWeight: 700,
  },
  // Alternativas sem borda: a escolhida é destacada em negrito.
  optionsGroup: {
    display: 'flex',
    flexDirection: 'column',
  },
  option: {
    marginLeft: 0,
  },
  optionSelectedLabel: {
    fontWeight: 700,
  },
  // Apontamentos do revisor: borda na cor do tipo, para diferenciar não
  // conformidade de melhoria sem depender só do ícone.
  auditLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  auditBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    padding: theme.spacing(1.5, 2),
    borderRadius: theme.shape.borderRadius,
    borderLeftWidth: 3,
    borderLeftStyle: 'solid',
    backgroundColor: theme.palette.background.default,
  },
  auditBoxNonConformity: {
    borderLeftColor: theme.palette.statusLabel.error.primary,
  },
  auditBoxImprovement: {
    borderLeftColor: theme.palette.statusLabel.pending.primary,
  },
  // Selo do resultado do save: só borda na cor do próprio texto, sem fundo.
  saveStateBadge: {
    border: '1px solid currentColor',
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(0, 0.75),
    whiteSpace: 'nowrap',
  },
  savingText: {
    color: theme.palette.text.secondary,
    fontWeight: 500,
  },
  savedText: {
    color: theme.palette.statusLabel.success.primary,
    fontWeight: 500,
  },
}))

export default styles
